import React from 'react';

export default function LinkCircle() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#18181B' />
      <path
        d='M9.99967 15.3337H8.66634C7.78229 15.3337 6.93444 14.9825 6.30932 14.3573C5.6842 13.7322 5.33301 12.8844 5.33301 12.0003C5.33301 11.1163 5.6842 10.2684 6.30932 9.6433C6.93444 9.01818 7.78229 8.66699 8.66634 8.66699H9.99967M13.9997 8.66699H15.333C16.2171 8.66699 17.0649 9.01818 17.69 9.6433C18.3152 10.2684 18.6663 11.1163 18.6663 12.0003C18.6663 12.8844 18.3152 13.7322 17.69 14.3573C17.0649 14.9825 16.2171 15.3337 15.333 15.3337H13.9997M9.33301 12.0003H14.6663'
        stroke='#A1A1AA'
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
